import { render, staticRenderFns } from "./ArchivedChatsButton.vue?vue&type=template&id=13fa45b6&"
import script from "./ArchivedChatsButton.vue?vue&type=script&lang=js&"
export * from "./ArchivedChatsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports